import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { ICourseBuilderState, ICourseBuilder } from '@/store/admin/types/types';

import { courseBuilderApi } from '@/api/admin/course-builder';
import type { RootState } from '@/store';
import type { IThunkAPI } from '@/store/types';

const initialState: ICourseBuilderState = {
  courseList: [],
  course: null,
};

export const getCourseBuilderListByClient = createAsyncThunk<Array<ICourseBuilder>, number, IThunkAPI>(
  'get/coursebuilder/list/client',
  async (clientId, thunkAPI) => {
    try {
      const response = await courseBuilderApi.getCourseListByClientId(clientId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getCourseBuilderById = createAsyncThunk<ICourseBuilder, number, IThunkAPI>(
  'get/coursebuilder/id',
  async (clientId, thunkAPI) => {
    try {
      const response = await courseBuilderApi.getCourseById(clientId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const addCourseBuilder = createAsyncThunk<unknown, ICourseBuilder, IThunkAPI>(
  'post/course/save',
  async (course, thunkAPI) => {
    try {
      const response = await courseBuilderApi.saveCourseBuilder(course);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const courseBuilderSlice = createSlice({
  name: 'courseBuilder',
  initialState,
  reducers: {
    clearCourseBuilderList(state) {
      state.courseList = [];
    },
    clearCourseBuilder(state) {
      state.course = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getCourseBuilderListByClient.fulfilled, (state, action) => {
        state.course = null;
        if (action.payload && action.payload instanceof Array) {
          state.courseList = action.payload;
        } else {
          state.courseList = [];
        }
      })
      .addCase(getCourseBuilderById.fulfilled, (state, action) => {
        if (action.payload && action.payload instanceof Object) {
          state.course = action.payload;
        } else {
          state.course = null;
        }
      });
  },
});

// actions
export const { clearCourseBuilder, clearCourseBuilderList } = courseBuilderSlice.actions;

// selectors
export const courseListAll = (state: RootState): ICourseBuilderState['courseList'] => state.courseBuilder.courseList;
export const course = (state: RootState): ICourseBuilderState['course'] => state.courseBuilder.course;

export default courseBuilderSlice.reducer;
